import styled from 'styled-components';
import { Colors } from 'axl-reactjs-ui';

export const Container = styled.div`
  overflow: auto;
  height: 100%;
`;
export const Inner = styled.div`
  overflow-y: auto;
  height: 100%;
  padding: 30px 17px 30px 25px;
  box-sizing: border-box;
`;
export const Title = styled.h3`
  font-size: 1.5rem;
  font-family: 'AvenirNext-Medium', sans-serif;
  margin: 0;
  flex: 1;
  text-align: center;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 30px;
`;
export const Col = styled.div``;
export const Label = styled.div`
  width: 65px;
  font-family: 'AvenirNext-Medium', sans-serif;
  font-size: 12.5px;
  font-weight: 500;
  letter-spacing: -0.1px;
  color: ${Colors.greyishBrown};
  text-align: left;
`;
export const Content = styled.div`
  flex: 1;
`;
export const Control = styled.div`
  margin-bottom: 5px;
`;

export const ButtonContent = styled.div`
  flex: 1;
  text-align: center;
`;

export default {
  container: {},
  noMargin: {
    margin: 0,
  },
  textarea: {
    resize: 'vertical',
    minHeight: 220
  }
}
